"use client";
import { useState } from "react";

type TabsContent = {
  id: React.ReactNode;
  en: React.ReactNode;
};

export default function AdminModal({
  open,
  onClose,
  title,
  children,
  tabs,
  onSubmit,
  isValid = true,
}: {
  open: boolean;
  onClose: () => void;
  title: string;
  children?: React.ReactNode;
  tabs?: TabsContent;
  onSubmit: (lang?: "id" | "en") => Promise<void> | void;
  isValid?: boolean; // <-- baru
}) {
  const [activeTab, setActiveTab] = useState<"id" | "en">("en");
  const [loading, setLoading] = useState(false);

  if (!open) return null;

  const handleSubmit = async (lang?: "id" | "en") => {
    setLoading(true);
    try {
      await onSubmit(lang);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black/40 backdrop-blur-sm flex items-center justify-center z-50">
      <div className="bg-white w-full max-w-sm md:max-w-2xl rounded-xl shadow-lg p-6 animate-fadeIn"
        onKeyDown={e => e.key === "Enter" && handleSubmit()}>

        <h2 className="text-xl font-semibold mb-4">{title}</h2>

        {tabs && (
          <div className="flex gap-4 border-b mb-4">
            <button
              className={`pb-2 ${activeTab === "en" ? "border-b-2 border-primary font-semibold" : ""}`}
              onClick={() => setActiveTab("en")}
            >
              English
            </button>
            <button
              className={`pb-2 ${activeTab === "id" ? "border-b-2 border-primary font-semibold" : ""}`}
              onClick={() => setActiveTab("id")}
            >
              Indonesia
            </button>
          </div>
        )}

        <div>{tabs ? tabs[activeTab] : children}</div>

        <div className="mt-6 flex justify-end gap-3">
          <button className="px-4 py-2 rounded-lg border" onClick={onClose} disabled={loading}>
            Cancel
          </button>

          {tabs && (
            <>
              {activeTab === "en" && (
                <button
                  className="px-4 py-2 rounded-lg bg-primary text-white disabled:opacity-50"
                  onClick={() => handleSubmit("en")}
                  disabled={loading || !isValid}
                >
                  {loading ? "Saving..." : "Save"}
                </button>
              )}

              {activeTab === "id" && (
                <button
                  className="px-4 py-2 rounded-lg bg-primary text-white disabled:opacity-50"
                  onClick={() => handleSubmit("id")}
                  disabled={loading || !isValid}
                >
                  {loading ? "Saving..." : "Save"}
                </button>
              )}
            </>
          )}

          {!tabs && (
            <button
              className="px-4 py-2 rounded-lg bg-primary text-white disabled:opacity-50"
              onClick={() => handleSubmit?.()}
              disabled={loading || !isValid} // <-- pakai isValid
            >
              {loading ? "Saving..." : "Save"}
            </button>
          )}
        </div>

      </div>
    </div>
  );
}
